// src/components/spatial/utils/drawPrint.js

import drawSpaceConfig from "../config/drawSpaceConfig";

const buildPrintStyles = (orientation = "landscape") => {
  const isLandscape = orientation === "landscape";

  const size = isLandscape ? "A4 landscape" : "A4 portrait";

  return `
    @page {
      size: ${size};
      margin: 12mm;
    }

    body {
      font-family: Arial, Helvetica, sans-serif;
      color: #0b2735;
    }

    .draw-print-wrapper {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: stretch;
      gap: 12px;
    }

    .draw-print-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      font-weight: 600;
    }

    .draw-print-meta {
      font-size: 12px;
      color: #3F5D6E;
    }

    .draw-print-canvas {
      border: 1px solid #d6dee4;
      padding: 6px;
    }

    svg {
      width: 100%;
      height: auto;
    }
  `;
};

export const printSpatialView = ({
  svgElement,
  title,
  assetLabel,
  floorLabel,
  elevation,
  orientation = drawSpaceConfig.print.defaultOrientation,
}) => {
  if (!svgElement) return;

  const printWindow = window.open("", "_blank");

  if (!printWindow) return;

  const clonedSvg = svgElement.cloneNode(true);

  const styles = buildPrintStyles(orientation);

  const html = `
    <html>
      <head>
        <title>${title}</title>
        <style>
          ${styles}
        </style>
      </head>
      <body>
        <div class="draw-print-wrapper">

          <div class="draw-print-header">
            <div>${title}</div>
            <div class="draw-print-meta">${assetLabel || ""}</div>
          </div>

          <div class="draw-print-meta">
            Level: ${floorLabel || "-"} | Elevation: ${elevation ?? 0} m
          </div>

          <div class="draw-print-canvas">
            ${clonedSvg.outerHTML}
          </div>

        </div>

        <script>
          window.onload = function () {
            window.focus();
            window.print();
            setTimeout(() => window.close(), 200);
          }
        </script>

      </body>
    </html>
  `;

  printWindow.document.open();
  printWindow.document.write(html);
  printWindow.document.close();
};